/* eslint-disable no-unused-vars */
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { FeatureService } from '../services/feature.service';
import { inject } from '@angular/core';
import { PopupEligibility } from '../models/popup.model';
import { Store } from '@ngrx/store';
import * as fromShared from '../store/selectors/shared.selector';
import { goToAction } from '../store/actions/shared.action';

export const popupGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const sharedStore$ = inject(Store<fromShared.State>);
  const featureService = inject(FeatureService);

  const popupId = route.params[`id`];

  return featureService.checkPopupEligibility(popupId).pipe(
    map((popupEligibility: PopupEligibility) => {
      if (!popupEligibility.success) {
        sharedStore$.dispatch(goToAction({ url: `` }));
      }

      return popupEligibility.success;
    }),
  );
};
